//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './WarrantyRequestSummaryClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetWarrantyRequestSummaryQueryParameters = {
  orderedFrom?: Date | null | undefined ;
  isOnlyWithRejectedParts?: boolean | undefined ;
  orderNumber?: string | null | undefined ;
  reference?: string | null | undefined ;
  offset?: number | null | undefined ;
  limit?: number | null | undefined ;
  sortBy?: string | null | undefined ;
  sortOrder?: Types.SortOrder | undefined ;
}

export function getUrl(orderedFrom?: Date | null | undefined, isOnlyWithRejectedParts?: boolean | undefined, orderNumber?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/warranty-request-summary?";
if (orderedFrom !== undefined && orderedFrom !== null)
    url_ += "OrderedFrom=" + encodeURIComponent(orderedFrom ? "" + Types.formatDate(orderedFrom) : "") + "&";
if (isOnlyWithRejectedParts === null)
    throw new Error("The parameter 'isOnlyWithRejectedParts' cannot be null.");
else if (isOnlyWithRejectedParts !== undefined)
    url_ += "IsOnlyWithRejectedParts=" + encodeURIComponent("" + isOnlyWithRejectedParts) + "&";
if (orderNumber !== undefined && orderNumber !== null)
    url_ += "OrderNumber=" + encodeURIComponent("" + orderNumber) + "&";
if (reference !== undefined && reference !== null)
    url_ += "Reference=" + encodeURIComponent("" + reference) + "&";
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDefaultOptions: Omit<UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, unknown, Types.WarrantyRequestSummaryResponseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, unknown, Types.WarrantyRequestSummaryResponseDto>, 'queryFn'>> = {
};
export function getGetDefaultOptions() {
  return getDefaultOptions;
};
export function setGetDefaultOptions(options: typeof getDefaultOptions) {
  getDefaultOptions = options;
}

export function getQueryKey(dto: GetWarrantyRequestSummaryQueryParameters): QueryKey;
export function getQueryKey(orderedFrom?: Date | null | undefined, isOnlyWithRejectedParts?: boolean | undefined, orderNumber?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { orderedFrom, isOnlyWithRejectedParts, orderNumber, reference, offset, limit, sortBy, sortOrder,  } = params[0] as GetWarrantyRequestSummaryQueryParameters;

    return trimArrayEnd([
        'WarrantyRequestSummaryClient',
        'get',
        orderedFrom as any,
        isOnlyWithRejectedParts as any,
        orderNumber as any,
        reference as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'WarrantyRequestSummaryClient',
        'get',
        ...params
      ]);
  }
}
export function __get(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.get(
      context.queryKey[2] as Date | null | undefined,       context.queryKey[3] as boolean | undefined,       context.queryKey[4] as string | null | undefined,       context.queryKey[5] as string | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as number | null | undefined,       context.queryKey[8] as string | null | undefined,       context.queryKey[9] as Types.SortOrder | undefined,axiosConfig    );
}

export function useGetQuery<TSelectData = Types.WarrantyRequestSummaryResponseDto, TError = unknown>(dto: GetWarrantyRequestSummaryQueryParameters, options?: Omit<UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets data.
 * @param orderedFrom (optional) Orders up from (vorgangseit)
 * @param isOnlyWithRejectedParts (optional) Orders where at least one part is rejected
 * @param orderNumber (optional) Order (Warranty request) number (tkbestellung)
 * @param reference (optional) Reference (frzeichen)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetQuery<TSelectData = Types.WarrantyRequestSummaryResponseDto, TError = unknown>(orderedFrom?: Date | null | undefined, isOnlyWithRejectedParts?: boolean | undefined, orderNumber?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: Omit<UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetQuery<TSelectData = Types.WarrantyRequestSummaryResponseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let orderedFrom: any = undefined;
  let isOnlyWithRejectedParts: any = undefined;
  let orderNumber: any = undefined;
  let reference: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ orderedFrom, isOnlyWithRejectedParts, orderNumber, reference, offset, limit, sortBy, sortOrder,  } = params[0] as GetWarrantyRequestSummaryQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [orderedFrom, isOnlyWithRejectedParts, orderNumber, reference, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.WarrantyRequestSummaryResponseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __get(context, axiosConfig) : __get,
    queryKey: getQueryKey(orderedFrom, isOnlyWithRejectedParts, orderNumber, reference, offset, limit, sortBy, sortOrder),
    ...getDefaultOptions as unknown as Omit<UseQueryOptions<Types.WarrantyRequestSummaryResponseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets data.
 * @param orderedFrom (optional) Orders up from (vorgangseit)
 * @param isOnlyWithRejectedParts (optional) Orders where at least one part is rejected
 * @param orderNumber (optional) Order (Warranty request) number (tkbestellung)
 * @param reference (optional) Reference (frzeichen)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetData(queryClient: QueryClient, updater: (data: Types.WarrantyRequestSummaryResponseDto | undefined) => Types.WarrantyRequestSummaryResponseDto, orderedFrom?: Date | null | undefined, isOnlyWithRejectedParts?: boolean | undefined, orderNumber?: string | null | undefined, reference?: string | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getQueryKey(orderedFrom, isOnlyWithRejectedParts, orderNumber, reference, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets data.
 * @param orderedFrom (optional) Orders up from (vorgangseit)
 * @param isOnlyWithRejectedParts (optional) Orders where at least one part is rejected
 * @param orderNumber (optional) Order (Warranty request) number (tkbestellung)
 * @param reference (optional) Reference (frzeichen)
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB (ABAS).
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.WarrantyRequestSummaryResponseDto | undefined) => Types.WarrantyRequestSummaryResponseDto) {
  queryClient.setQueryData(queryKey, updater);
}